import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td } from "@chakra-ui/react";
import { DateFilter, TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import apiCall from '../../../utils/apiCall';
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { downloadApi } from "../../../api";
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom } from "../../../context";
import { Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { format } from "date-fns";
import moment from "moment";

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function MovedToMembershipReport() {
  const [activeIndex] = useAtom(indexAtom);
  const queryClient = useQueryClient();
  const [, set_open] = useAtom(openAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage] = useState(100);
  const [search, set_search] = useState('');
  const [date_range, set_date_range] = useState<any>({ start: '', end: '' });

  // Normalize date values once
  const cleanStart = date_range.start
    ? moment(date_range.start).format("YYYY-MM-DD")
    : "";

  const cleanEnd = date_range.end
    ? moment(date_range.end).format("YYYY-MM-DD")
    : "";

  // Reset to first page when search/date changes
  useEffect(() => {
    setPageNumber(1);
  }, [search, cleanStart, cleanEnd]);

  // Main query
  const {
    data: pagedData,
    isLoading,
  } = useQuery(
    ['moved-membership', pageNumber, search, cleanStart, cleanEnd],
    async () => {
      const response = await apiCall().get(
        `/Exam/students/movedToMembership?PageNumber=${pageNumber}&PageSize=${itemsPerPage}&searchQuery=${search}&startDate=${cleanStart}&endDate=${cleanEnd}`
      );
      return response.data;
    },
    {
      keepPreviousData: true,
      select: (data: any) => ({
        items: data.reportItems,
        totalCount: data.TotalCount,
        pageCount: data.PageCount,
      }),
    }
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    set_search(e.target.value);
  };

  const handlePageClick = (event: any) => {
    setPageNumber(event.selected + 1);
  };

  // Download mutation
  const { mutate: handleDownload, isLoading: isDownloading } = useMutation({
    mutationKey: ['download-moved-membership'],
    mutationFn: async () => {
      const url = `/ExamReport/downloadMovedToMembershipReport?startDate=${
        cleanStart || '1900-01-01'
      }&endDate=${cleanEnd || '2100-12-31'}`;

      return await downloadApi(url, 'POST', {}, {}, true);
    },
    onSuccess: (file: any) => {
      if (file) {
        const url = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'StudentMovedToMember-report-list.xlsx');
        document.body.appendChild(link);
        link.click();

        set_notification({
          type: 'success',
          message: 'Download successful',
        });
        set_Nopen(true);
      } else {
        set_notification({
          type: 'error',
          message: 'Error occurred trying to download file',
        });
        set_Nopen(true);
      }
    },
    onError: (error: any) => {
      set_notification({
        type: 'error',
        message: error?.data?.Message || 'Error occurred',
      });
      set_Nopen(true);
    },
    onSettled: () => set_open(false),
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Box>
          <TopDisplay
            label="Student Moved To Member Report"
            button_array={[
              <Button
                key="download"
                color="var(--white-color)"
                bg="var(--dark-green-color)"
                leftIcon={<DownloadIcon />}
                onClick={() => handleDownload()}
                disabled={isDownloading}
              >
                {isDownloading ? 'Downloading...' : 'Download Student Moved To Member Report'}
              </Button>,
            ]}
          />

          {/* Filters */}
          <Flex gap="20px" wrap="wrap" mt="20px">
            <InputGroup
              h="40px"
              width="300px"
              bg="var(--white-color)"
              borderColor="var(--dark-green-color)"
            >
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.300" />
              </InputLeftElement>

              <Input
                value={search}
                onChange={handleSearch}
                placeholder="Search by Student No or Name"
              />

              <span
                style={{
                  position: 'absolute',
                  zIndex: 1,
                  right: '10px',
                  cursor: 'pointer',
                  top: '12px',
                }}
                onClick={() => {
                  set_search('');
                  setPageNumber(1);
                }}
              >
                <ReloadIcon />
              </span>
            </InputGroup>

            {/* <DateFilter text="Date Range" onChange={set_date_range} /> */}
          </Flex>

          {/* Table Header */}
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">
              All Student Moved To Member Report
            </Heading>
            <Text m="0" fontSize=".8rem">
              Showing {(pagedData?.items?.length || 0) * (pageNumber - 1) + 1}–
              {Math.min(pageNumber * itemsPerPage, pagedData?.totalCount || 0)} of{' '}
              {pagedData?.totalCount || 0}
            </Text>
          </Flex>

          {/* Table */}
          {pagedData?.items?.length ? (
            <TableContainer mt="20px">
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th sx={HeadStyle}>Student No</Th>
                    <Th sx={HeadStyle}>First Name</Th>
                    <Th sx={HeadStyle}>Last Name</Th>
                    <Th sx={HeadStyle}>IsOldStudent?</Th>
                    <Th sx={HeadStyle}>IsMoved?</Th>
                    <Th sx={HeadStyle}>FinalMembershipNo</Th>
                    <Th sx={HeadStyle}>Date inducted</Th>
                    <Th sx={HeadStyle}>Date Migrated</Th>
                    <Th sx={HeadStyle}>Status</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {pagedData.items.map((eCandidate: any) => (
                    <ROWSTYLE key={eCandidate.StudentNo}>
                      <Td sx={DataStyle}>{eCandidate.StudentNo}</Td>
                      <Td sx={DataStyle}>{eCandidate.FirstName}</Td>
                      <Td sx={DataStyle}>{eCandidate.LastName}</Td>
                      <Td sx={DataStyle}>{eCandidate.IsOldStudent ? 'Yes' : 'No'}</Td>
                      <Td sx={DataStyle}>{eCandidate.IsMovedToMembership ? 'Yes' : 'No'}</Td>
                      <Td sx={DataStyle}>{eCandidate.FinalMembershipNo || 'N/A'}</Td>
                      <Td sx={DataStyle}>
                        {eCandidate.DateInducted
                          ? moment(eCandidate.DateInducted).format('YYYY-MM-DD')
                          : 'N/A'}
                      </Td>
                      <Td sx={DataStyle}>
                        {eCandidate.DateMigrated
                          ? moment(eCandidate.DateMigrated).format('YYYY-MM-DD')
                          : 'N/A'}
                      </Td>
                      <Td sx={DataStyle}>{eCandidate.Status}</Td>
                    </ROWSTYLE>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            'No Student Moved To Member report'
          )}

          {/* Pagination */}
          <StylePaginateBox>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pagedData?.pageCount || 0}
              previousLabel="<"
              renderOnZeroPageCount={null}
            />
          </StylePaginateBox>
        </Box>
      )}
    </>
  );
}


const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}
